import Skeleton from 'app/components/base/Skeleton'
import Text from 'app/components/base/Text'

interface HelpCenterTitleProps {
  title?: string
  isLoading?: boolean
}

const HelpCenterTitle = ({ title, isLoading }: HelpCenterTitleProps) => {
  return (
    <Skeleton
      loading={isLoading}
      sx={{ width: '50%', height: 32, pt: { xs: 0, md: 1 } }}
    >
      <Text variant="h3" sx={{ pt: { xs: 0, md: 1 } }}>
        {title}
      </Text>
    </Skeleton>
  )
}

export default HelpCenterTitle
